<div class="invitation-detail-container">
  <app-page-title
    title="รายละเอียดคำเชิญดำเนินการแทน"
    description="ตรวจสอบข้อมูลและตอบรับหรือปฏิเสธคำเชิญให้ดำเนินการแทนจากผู้มอบสิทธิ์">
  </app-page-title>

  @if (loading()) {
    <div class="loading-state">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">กำลังโหลด...</span>
      </div>
      <p class="mt-2 text-muted">กำลังโหลดข้อมูล...</p>
    </div>
  } @else if (item()) {
    <div class="detail-card">
      <div class="detail-card-header">
        <div>
          <!--          <h4 class="card-title mb-1">การมอบหมายสิทธิ์ดำเนินการแทน</h4>-->
          <span class="text-muted small">รหัสคำเชิญ: #{{ item()?.id }}</span>
        </div>
      </div>

      <div class="detail-card-body">
        <div class="detail-grid">
          <div class="detail-item">
            <label class="item-label">ผู้มอบสิทธิ์</label>
            <div class="item-value fw-semibold grantor-name">
              {{ item()?.grantorName || '-' }}
            </div>
          </div>

          <div class="detail-item">
            <label class="item-label">เลขประจำตัวผู้เสียภาษี (ผู้มอบสิทธิ์)</label>
            <div class="item-value">{{ item()?.grantorTaxId || '-' }}</div>
          </div>

          <div class="detail-item">
            <label class="item-label">ผู้รับมอบสิทธิ์</label>
            <div class="item-value fw-semibold">
              {{ item()?.delegateName || '-' }}
            </div>
          </div>

          <div class="detail-item">
            <label class="item-label">เลขประจำตัวผู้เสียภาษี (ผู้รับมอบสิทธิ์)</label>
            <div class="item-value">{{ item()?.delegateTaxId || '-' }}</div>
          </div>

          <div class="detail-item full-width">
            <label class="item-label">ธุรกิจที่เกี่ยวข้อง</label>
            <div class="item-value">
              @if ((item()?.businesses?.length ?? 0) > 0) {
                <ul class="business-nested-list">
                  @for (business of item()!.businesses!; track business.id ?? business.businessName) {
                    <li>
                      <span class="fw-semibold">{{ business.businessName || 'ไม่ระบุธุรกิจ' }}</span>
                      @if (business.businessCode) {
                        <span>({{ business.businessCode }})</span>
                      }
                      @if ((business.certificates?.length ?? 0) > 0) {
                        <ul class="business-sub-list">
                          @for (cert of business.certificates!; track $index) {
                            <li>
                              <span class="sub-label">มาตรฐาน: </span>{{ cert.standardName || cert.standardCode }}
                              @if (cert.standardName && cert.standardCode) {
                                <span>({{ cert.standardCode }})</span>
                              }
                              @if (cert.certificateNo) {
                                <div>
                                  <span class="sub-label">ใบรับรองเลขที่: </span>{{ cert.certificateNo }}
                                </div>
                              }
                            </li>
                          }
                        </ul>
                      }
                      <ul class="business-sub-list">
                        <li>
                          <span class="sub-label">การดำเนินการที่มอบหมาย: </span>
                          @if (item()?.actions && item()!.actions!.length > 0) {
                            @for (action of item()!.actions!; track action; let last = $last) {
                              {{ getActionLabel(action) }}@if (!last) {
                                <span>, </span>
                              }
                            }
                          } @else {
                            บันทึกซื้อ-ขาย
                          }
                        </li>
                      </ul>
                    </li>
                  }
                </ul>
              } @else {
                ไม่ระบุธุรกิจ
              }
            </div>
          </div>

          <div class="detail-item">
            <label class="item-label">วันที่ส่งคำเชิญ</label>
            <div class="item-value">{{ formatDate(item()?.createdAt) }}</div>
          </div>

          @if (item()?.startsOn || item()?.endsOn) {
            <div class="detail-item">
              <label class="item-label">ระยะเวลามอบสิทธิ์</label>
              <div class="item-value">
                {{ formatDateOnly(item()?.startsOn) }} - {{ formatDateOnly(item()?.endsOn) }}
              </div>
            </div>
          }

          <div class="detail-item"
               [class.full-width]="item()?.invitationStatus === 'ACCEPTED' || item()?.invitationStatus === 'REJECTED'">
            <label class="item-label">สถานะคำเชิญ</label>
            <div class="item-value">
              @if (!item()?.invitationStatus || item()?.invitationStatus === 'PENDING') {
                <span class="status-badge" [class]="getStatusClass(item()?.invitationStatus)">
                  {{ getStatusLabel(item()?.invitationStatus) }}
                </span>
              }
              @if (item()?.invitationStatus === 'ACCEPTED') {
                <div class="status-notice notice-success mt-2 mb-0">
                  <i class="bi bi-check-circle-fill fs-5"></i>
                  <div>
                    <strong>ตอบรับแล้ว: </strong>
                    ท่านได้ตอบรับคำเชิญนี้เมื่อวันที่ {{ formatDate(item()?.respondedDate) }}
                  </div>
                </div>
              } @else if (item()?.invitationStatus === 'REJECTED') {
                <div class="status-notice notice-danger mt-2 mb-0">
                  <i class="bi bi-x-circle-fill fs-5"></i>
                  <div>
                    <strong>ปฏิเสธแล้ว: </strong>
                    ท่านได้ปฏิเสธคำเชิญนี้เมื่อวันที่ {{ formatDate(item()?.respondedDate) }}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="detail-card-footer">
        <a routerLink="/profile/role-invitations" class="btn btn-outline-secondary">
          ย้อนกลับ
        </a>

        @if (item()?.invitationStatus === 'PENDING') {
          <div class="action-buttons">
            <button type="button"
                    class="btn btn-outline-danger"
                    [disabled]="processing()"
                    (click)="onReject()">
              @if (processing()) {
                <span class="spinner-border spinner-border-sm me-1"></span>
              } @else {
                <i class="bi bi-x-lg me-1"></i>
              }
              ปฏิเสธคำเชิญ
            </button>

            <button type="button"
                    class="btn btn-primary"
                    [disabled]="processing()"
                    (click)="onAccept()">
              @if (processing()) {
                <span class="spinner-border spinner-border-sm me-1"></span>
              } @else {
                <i class="bi bi-check-lg me-1"></i>
              }
              ตอบรับคำเชิญ
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
